import { request } from './request.js'

export const getServices = () => request.get('services')
export const getServicesById = (id) => request.get('services/' + id)
export const getServicesBases = () => request.get('service-bases')
export const getContacts = () => request.get('contacts')
export const postMailToTocin = (data) => request.post('mail-to-tocin', data)
